<template>
  <!-- <nav>
    <my-icon>
      <img style="height: 100px;" src="/cocktail (20231105111207).png" alt="">
    </my-icon>
    <div style="margin-left: auto; font-size: 75px;">Bar</div>
    <div style="margin-left: auto;">
      <my-button>profile</my-button>
    </div>
  </nav> -->
  <!-- <router-link to="/">Bar</router-link> -->

  <router-view></router-view>
</template>


<script>
export default {}
</script>


<style>
* {
  font-size: 35px;
  font-family: sans-serif;
  font-style: normal;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* box-sizing: content-box; */
  block-size: auto;

  --bar-color-main: #ff7d33;
  --bar-color-light: #feaa60c9;
  --bar-color-back: #fae5d3;
  --bar-color-active: #ffd0a8;

  color: var(--bar-color-main);
}
img {
  display: block;
}
</style>
